import * as React from 'react';
import styled from 'styled-components';

// ############################ Styles ###########################
// tslint:disable:variable-name

const STooltipWrap = styled.section`
  display: inline-block;
  vertical-align: middle;
`;

const STooltipShow = styled.section`
  display: flex;
  cursor: pointer;
`;

const STooltip = styled.section<{ positionTop: number; positionLeft: number; fitWidthToContent: boolean }>(
  ({ theme, positionTop, positionLeft, fitWidthToContent }) => {
    return `
  display: flex;
  position: absolute;
  top: ${positionTop}px;
  left: ${positionLeft}px;
  padding: ${theme.spacing.small}px ${theme.spacing.medium}px;
  width: ${fitWidthToContent ? 'auto' : 'calc(100% - 82px)'};
  border: 1px solid ${theme.colors.border};
  background-color: ${theme.colors.white};
  border-radius: ${theme.borderRadiusCommon}px;
  color: ${theme.colors.black};
  text-align: left;
  font-size: ${theme.font.size.small};
  z-index: 10;
  height: fit-content;
`;
  }
);

// tslint:enable:variable-name
// ############################ End Styles ###########################

interface ITooltip {
  toggler: React.ReactNode;
  dismissButton?: React.RefObject<HTMLElement>;
  dataAt: string;
  className?: string;
  positionTop?: number;
  positionLeft?: number;
  fitWidthToContent?: boolean;
}

// tslint:disable-next-line:variable-name
const TooltipDinamic: React.FC<ITooltip> = (props) => {
  const [tooltipVisible, setTooltipVisible] = React.useState(false);
  const [tooltipPositionTop, setTooltipPositionTop] = React.useState(props.positionTop || 0);
  const tooltipPositionLeft = props.positionLeft || 30;
  const tooltipFitWidth = props.fitWidthToContent || false;
  const tooltipWrapNode = React.useRef<HTMLElement>(null);

  const hideTooltip = () => {
    setTooltipVisible(false);
  };

  const tooltipVisibleOff = (e: MouseEvent) => {
    if (tooltipWrapNode && tooltipWrapNode.current && tooltipWrapNode.current.contains(e.target as HTMLElement)) {
      const { scrollY } = window;
      const { top, height } = tooltipWrapNode.current.getBoundingClientRect();
      const tooltipTopPositon: number = props.positionTop || top + scrollY + height;
      setTooltipPositionTop(tooltipTopPositon);
      return;
    }
    hideTooltip();
  };

  const toggleTooltipVisible = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setTooltipVisible(!tooltipVisible);
    return false;
  };

  React.useEffect(() => {
    // add when mounted
    document.addEventListener('mousedown', tooltipVisibleOff); // return function to be called when unmounted

    // remove when unmounted
    return () => {
      document.removeEventListener('mousedown', tooltipVisibleOff);
    };
  }, []);

  React.useEffect(() => {
    tooltipVisible && props.dismissButton?.current?.addEventListener('mousedown', hideTooltip);
  }, [tooltipVisible]);

  return (
    <STooltipWrap ref={tooltipWrapNode} className={props.className}>
      <STooltipShow onClick={toggleTooltipVisible}>{props.toggler}</STooltipShow>
      {tooltipVisible && (
        <STooltip
          className="tooltip-container"
          data-at={props.dataAt + '-content'}
          positionTop={tooltipPositionTop}
          positionLeft={tooltipPositionLeft}
          fitWidthToContent={tooltipFitWidth}
        >
          {props.children}
        </STooltip>
      )}
    </STooltipWrap>
  );
};

export default TooltipDinamic;
